module.exports = {
      id: "icon-open-in-new-usage",
      viewBox: "0 0 24.047 24.047",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-open-in-new",
      toString: function () {
        return this.url;
      }
    }